/**
 * Configuracao e utilitarios do refresh automatico das telas de listagem.
 *
 * As telas fazem polling porque o backend nao expoe push (websocket/SSE):
 * para saber se algo mudou e preciso perguntar. O que fazemos aqui e evitar
 * o custo de redesenhar a tabela quando a resposta e identica a anterior.
 */

/**
 * Intervalo do refresh automatico (1 minuto).
 * Todas as telas de listagem usam este valor - ajuste em um lugar so.
 */
export const INTERVALO_ATUALIZACAO_MS = 60_000;

/**
 * true quando as duas listas tem exatamente o mesmo conteudo.
 *
 * Usado no polling para nao reatribuir a lista (e redesenhar a p-table)
 * quando a resposta nao trouxe novidade. As respostas sao pequenas (pagina de
 * 20 registros), entao a comparacao via JSON e barata e suficiente.
 */
export function mesmaLista<T>(
  atual: T[] | null | undefined,
  novo: T[] | null | undefined
): boolean {
  if (atual === novo) {
    return true;
  }

  if (!atual || !novo || atual.length !== novo.length) {
    return false;
  }

  return JSON.stringify(atual) === JSON.stringify(novo);
}
